var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "900" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("column")))]),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-card-content" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("w-select", {
                    attrs: {
                      value: _vm.columnType,
                      label: _vm.$ct("column-type"),
                      fancy: "",
                      items: _vm.columnTypes,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.setColumnType($event)
                      },
                    },
                  }),
                  _vm.columnType == "default"
                    ? _c("app-column-select", {
                        attrs: {
                          model: _vm.model,
                          "is-filter": false,
                          browse: _vm.browse,
                          "is-server-column": "",
                        },
                        on: {
                          inputLabel: function ($event) {
                            _vm.value.Name = $event
                          },
                        },
                        model: {
                          value: _vm.value.Value,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "Value", $$v)
                          },
                          expression: "value.Value",
                        },
                      })
                    : _vm.columnType == "sum"
                    ? _c("app-select-columns-sum-cols-config", {
                        attrs: {
                          model: _vm.model,
                          column: _vm.value,
                          browse: _vm.browse,
                        },
                      })
                    : _vm.columnType == "goTemplate"
                    ? [
                        _c("w-textarea-autogrow", {
                          attrs: {
                            "max-height": 1000,
                            "min-height": 150,
                            resize: "",
                            fancy: "",
                            label: _vm.$ct("template-code"),
                          },
                          model: {
                            value: _vm.goTemplate,
                            callback: function ($$v) {
                              _vm.goTemplate = $$v
                            },
                            expression: "goTemplate",
                          },
                        }),
                        _c("w-textarea-autogrow", {
                          attrs: {
                            "max-height": 1000,
                            "min-height": 150,
                            resize: "",
                            fancy: "",
                            label: _vm.$ct(
                              "additional-preloads-new-line-seperated"
                            ),
                          },
                          model: {
                            value: _vm.additionalPreloads,
                            callback: function ($$v) {
                              _vm.additionalPreloads = $$v
                            },
                            expression: "additionalPreloads",
                          },
                        }),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "w-scroll-view",
                {
                  attrs: {
                    tag: "w-col",
                    "tag-attributes": { xs: "12", md: "6" },
                  },
                },
                [
                  _vm.isJson
                    ? _c("app-browse-column-select-json-property", {
                        staticClass: "mb",
                        attrs: {
                          browse: _vm.browse,
                          column: _vm.value.Value,
                          fancy: "",
                        },
                        model: {
                          value: _vm.value.JsonProperty,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "JsonProperty", $$v)
                          },
                          expression: "value.JsonProperty",
                        },
                      })
                    : _vm._e(),
                  _c("w-input", {
                    staticClass: "mb",
                    attrs: { fancy: "", label: _vm.$ct("column-name") },
                    model: {
                      value: _vm.value.Name,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "Name", $$v)
                      },
                      expression: "value.Name",
                    },
                  }),
                  _c("w-input-number", {
                    staticClass: "mb",
                    attrs: {
                      fancy: "",
                      label: _vm.$ct("column-width"),
                      decimals: 0,
                    },
                    model: {
                      value: _vm.value.Width,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "Width", $$v)
                      },
                      expression: "value.Width",
                    },
                  }),
                  _c("w-checkbox", {
                    staticClass: "mt",
                    attrs: {
                      label: _vm.$ct("calc-total"),
                      disabled: _vm.propIsNotNumber,
                    },
                    model: {
                      value: _vm.value.Total,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "Total", $$v)
                      },
                      expression: "value.Total",
                    },
                  }),
                  _c("w-checkbox", {
                    attrs: {
                      label: _vm.$ct("cumulative"),
                      disabled: _vm.propIsNotNumber,
                    },
                    model: {
                      value: _vm.value.Cumulative,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "Cumulative", $$v)
                      },
                      expression: "value.Cumulative",
                    },
                  }),
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("word-wrap") },
                    model: {
                      value: _vm.value.WordWrap,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "WordWrap", $$v)
                      },
                      expression: "value.WordWrap",
                    },
                  }),
                  _c("div", { staticClass: "fallback-container mt" }, [
                    _c("div", { staticClass: "fallback-label" }, [
                      _vm._v(" " + _vm._s(_vm.$ct("fallback")) + " "),
                    ]),
                    _c(
                      "div",
                      { staticClass: "fallback-actions" },
                      [
                        _vm._v(" " + _vm._s(_vm.fallbackName) + " "),
                        _c("w-spacer"),
                        _c(
                          "w-button",
                          {
                            attrs: { flat: "", disabled: _vm.fallbackDisabled },
                            on: {
                              click: function ($event) {
                                _vm.editFallback = true
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "pen" } })],
                          1
                        ),
                        _c(
                          "w-button",
                          {
                            attrs: {
                              flat: "",
                              disabled:
                                _vm.value.Fallback == "" ||
                                _vm.fallbackDisabled,
                            },
                            on: {
                              click: function ($event) {
                                _vm.value.Fallback = ""
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "trash" } })],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("app-text-if-value-settings", {
                    attrs: {
                      disabled: _vm.textIfValueDisabled,
                      settings: _vm.value.TextIfValueSettings,
                      model: _vm.model,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check", disabled: _vm.confirmedDisabled },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.confirm")) + " ")]
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.editFallback,
            callback: function ($$v) {
              _vm.editFallback = $$v
            },
            expression: "editFallback",
          },
        },
        [
          _vm.editFallback
            ? _c("app-select-fallback-column", {
                attrs: { value: _vm.value, model: _vm.model },
                on: {
                  close: function ($event) {
                    _vm.editFallback = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }